import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { JOBS_PORTAL_URL } from '../../Services/Services';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import ClipLoader from 'react-spinners/ClipLoader';
import './CreateJobs.css';

const API_URL = `${JOBS_PORTAL_URL}/api/jobs`;

const CreateJob = () => {
    const userId = localStorage.getItem('userId');

    const [formData, setFormData] = useState({
        title: '',
        description: '',
        company: '',
        location: '',
        type: '',
        no_of_openings: '',
        clientEmail: '',
        ctc: '',
        clientId: userId
    });

    const [loading, setLoading] = useState(false);
    const [toastId, setToastId] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        if (!userId) {
            navigate("/login");
        }
    }, [navigate, userId]);

    const showToast = (message, type = 'success') => {
        if (toastId) {
            toast.dismiss(toastId);
        }
        const id = toast[type](message);
        setToastId(id);
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const noOfOpenings = parseInt(formData.no_of_openings);
        const ctc = parseFloat(formData.ctc);

        if (
            !formData.title ||
            !formData.description ||
            !formData.company ||
            !formData.location ||
            !formData.type ||
            !formData.clientEmail ||
            !formData.ctc ||
            !formData.no_of_openings
        ) {
            showToast('Please fill in all the fields.', 'error');
            return;
        }

        if (isNaN(noOfOpenings) || noOfOpenings <= 0) {
            showToast('Number of openings must be a positive number.', 'error');
            return;
        }

        if (isNaN(ctc) || ctc <= 0) {
            showToast('CTC must be a positive number.', 'error');
            return;
        }

        setLoading(true);

        try {
            const payload = {
                ...formData,
                no_of_openings: noOfOpenings,
                ctc: ctc
            };

            await axios.post(API_URL, payload);
            showToast('Job posted successfully!');

            setFormData({
                title: '',
                description: '',
                company: '',
                location: '',
                type: '',
                no_of_openings: '',
                clientEmail: '',
                ctc: '',
                clientId: userId
            });

        } catch (err) {
            console.error(err);
            showToast('Failed to create job', 'error');
        } finally {
            setLoading(false);
        }
    };


    return (
        <div className="create-job-container">
            <h2>Create New Job Posting</h2>
            <form className="job-form" onSubmit={handleSubmit}>
                <input name="title" placeholder="Job Title" value={formData.title} onChange={handleChange} required />
                <textarea name="description" placeholder="Job Description" value={formData.description} onChange={handleChange} required />
                <input name="company" placeholder="Company" value={formData.company} onChange={handleChange} required />
                <input name="location" placeholder="Location" value={formData.location} onChange={handleChange} required />
                <input name="type" placeholder="Job Type (e.g., Full-time)" value={formData.type} onChange={handleChange} required />
                <input
                    type="number"
                    name="no_of_openings"
                    placeholder="Number of Openings"
                    value={formData.no_of_openings}
                    onChange={handleChange}
                    required
                    min="1"
                />
                <input type="email" name="clientEmail" placeholder="Client Email" value={formData.clientEmail} onChange={handleChange} required />
                <input
                    type="number"
                    name="ctc"
                    placeholder="CTC (Annual)"
                    value={formData.ctc}
                    onChange={handleChange}
                    required
                    min="1"
                />
                <button type="submit" className="btn submit" disabled={loading}>
                    {loading ? 'Posting...' : 'Post Job'}
                </button>

                {loading && (
                    <div style={{ marginTop: '20px', display: 'flex', justifyContent: 'center' }}>
                        <ClipLoader color="#36d7b7" loading={loading} size={35} />
                    </div>
                )}
            </form>
        </div>
    );
};

export default CreateJob;
